"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setLocaleToInstance = exports.format = exports.initial = void 0;
var string_format_1 = __importDefault(require("./string-format"));
var const_1 = require("../../const");
var index_1 = require("../index");
function getInstances() {
    if (!window[const_1.PANDA_INSTANCES]) {
        window[const_1.PANDA_INSTANCES] = {};
    }
    return window[const_1.PANDA_INSTANCES];
}
function initial(strings, options) {
    var name = options.name, lang = options.lang;
    var instances = getInstances();
    var stringFormat = new string_format_1.default(strings, lang);
    instances[name] = stringFormat;
}
exports.initial = initial;
function format(des, variable, options) {
    var _a = options || {}, name = _a.name, nameSpace = _a.nameSpace, lang = _a.lang;
    var instances = getInstances();
    // 当nameSpace不为空切不等于name时，则去找到ns相关实例
    var instance;
    if (!nameSpace || nameSpace === name) {
        instance = instances[name];
    }
    else {
        // 在查找的ns的name时，为了保证找到的准确性，在找到lang语种的时候去会得到置入该语种的nameSpace的name
        // 由于存在老的实例 使用的key是strings 所以只判断新的locale的key
        var findName = Object.keys(instances).find(function (key) { return key.startsWith(nameSpace) && instances[key].locale && instances[key].locale[lang]; })
            || Object.keys(instances).find(function (key) { return key.startsWith(nameSpace); });
        instance = instances[findName];
    }
    if (!instance) {
        (0, index_1.warn)("No translation found, pls make sure u passed the translation b4 1st $i18n.get func.");
        (0, index_1.debugError)({
            instanceName: name,
            translationId: des.id
        });
        return des.defaultString || des.id || '';
    }
    var string = instance.format(des, variable, options);
    return string;
}
exports.format = format;
function setLocaleToInstance(locale, name) {
    var instances = getInstances();
    var instance = instances[name];
    if (!instance) {
        (0, index_1.warn)('No translation found');
        (0, index_1.debugError)({
            instanceName: name,
        });
        return;
    }
    instance.setLocale(locale);
}
exports.setLocaleToInstance = setLocaleToInstance;
